import { render } from "./BaseRoundedCheckBox.vue?vue&type=template&id=f8902c3c&scoped=true"
import script from "./BaseRoundedCheckBox.vue?vue&type=script&lang=js"
export * from "./BaseRoundedCheckBox.vue?vue&type=script&lang=js"

import "./BaseRoundedCheckBox.vue?vue&type=style&index=0&id=f8902c3c&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f8902c3c"]])

export default __exports__